import React from 'react';
import { Button } from './ui/button';
import { Leaf } from 'lucide-react';

const ResponsibleSourcing = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="mb-6">
              <Leaf size={48} className="text-gray-700" />
            </div>
            <h2 className="text-3xl font-light mb-4 text-gray-800">
              Responsible Sourcing
            </h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              As a people and planet over profit company, we are committed to taking thoughtful and impactful steps towards a mindful and responsible approach to our business. It's imperative that we are bold and transparent in the face of injustice, pulling back the curtain on this industry and putting action behind our ethos.
            </p>
            <Button
              variant="outline"
              className="border-gray-800 text-gray-800 hover:bg-gray-800 hover:text-white transition-all duration-300"
            >
              Tell Me More
            </Button>
          </div>
          <div>
            <img
              src="https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=800&q=80"
              alt="Responsible Sourcing"
              className="w-full rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResponsibleSourcing;